import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

import { InputFileType } from './get-url-to-upload-file'

export interface BatchFilesResponse {
  originalFilename: string
  url: string
}

export async function getURLToUploadBatchFiles(
  treatment: Treatment,
  culture: Culture,
  demandId: string,
  type: InputFileType,
  batchFiles: string[],
  inputType?: string,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.post<BatchFilesResponse[]>(
    apiRoutes.getURLToUploadBatchFiles(treatment, culture, demandId, type),
    { batchFiles, inputType },
    options,
  )

  return data
}
